import React from 'react';

// Eager styles remain readable even when a required application CSS/JS chunk
// is unavailable. No source/error payload or credentials are displayed.
export const bootstrapStyle = { minHeight: '100vh', padding: 32, color: '#202124', background: '#f8f9fb', fontFamily: 'Arial, sans-serif' };

/** @extends {React.Component<{children: React.ReactNode, onRetry: () => void}, {failed: boolean}>} */
export default class AppBootstrapBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }

  render() {
    if (!this.state.failed) return this.props.children;
    return <main role="alert" style={bootstrapStyle}>
      <h1 tabIndex={-1} ref={node => node?.focus()}>Application unavailable</h1>
      <p>The current application files could not be loaded or started. No alternate application or accounting authority has been selected.</p>
      <button type="button" onClick={this.props.onRetry} style={{ padding: '12px 18px', color: '#e5edf5', background: '#16334d', border: '2px solid #61d6ff', borderRadius: 4 }}>Retry current application</button>
    </main>;
  }
}
